import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {

  loader: BehaviorSubject<any> = new BehaviorSubject<any>(true);
  constructor() {
    //tslint:disable:no-empty
    //@ts-ignore
   }

  start(type?) {
    const options = {
      isDisplay: false,
      type: type ? type : 'mega',
    };
    this.loader.next(options);
  }

  startWithLoadingTexts(loadingTexts: string []) {
    const options = {
      isDisplay: false,
      type: 'mega',
      loadingTexts: loadingTexts
    };
    this.loader.next(options);
  }
  
  stop(type?) {
    const options = {
      isDisplay: true,
      type: type ? type : 'mega',
    };
    this.loader.next(options);
  }
}
